import { createApp } from 'vue'
import Swiper from 'swiper/bundle';
import App from '../subscription/App.vue';


const el = document.querySelector('.subscription-page');
if (el) {
  const customer = {
    customerStatus: el.dataset.customerStatus || '',
    isVerified: el.dataset.isverified || '',
    phone: el.dataset.phone || '',
    id: el.dataset.id || ''
  }
  createApp(App, {
    customer,
  }).mount(el)
}


function updateSwiperStatus(swiper) {
  const statusEl = swiper.el.querySelector('.swiper-status');
  if (!statusEl) return;

  const total = swiper.slides.length;

  let perView = swiper.params.slidesPerView;
  if (perView === 'auto') {
    perView = swiper.slidesPerViewDynamic();
  }
  if (typeof perView !== 'number' || perView <= 0) perView = 1;

  const current = swiper.realIndex + 1;

  let message;

  if (perView === 1) {
    message = Shopify.locale === 'uk'
      ? `Слайд ${current} з ${total}`
      : `Слайд ${current} из ${total}`;
  }
  else {
    const start = current;
    const end = Math.min(start + perView - 1, total);

    message = Shopify.locale === 'uk'
        ? `Слайди ${start}–${end} з ${total}`
        : `Слайды ${start}–${end} из ${total}`;
  }

  statusEl.textContent = message;
}

const AUTOPLAY_DELAY = 5000; // 5s

let lastActiveIndex = 0;

// const subscribeBanner = new Swiper('.subscription-page__banner-wrapper', {
//   slidesPerView: 5,
//   spaceBetween: 12,
//   autoplay: {
//     delay: AUTOPLAY_DELAY,
//     disableOnInteraction: false,
//   },
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true,
//   },
//   a11y: {
//     enabled: true,
//     slideLabelMessage: '',
//     paginationBulletMessage:
//       Shopify.locale === 'uk'
//         ? 'Перейти до слайду {{index}}'
//         : 'Перейти к слайду {{index}}',
//     nextSlideMessage:
//       Shopify.locale === 'uk' ? 'Наступний слайд' : 'Следующий слайд',
//     prevSlideMessage:
//       Shopify.locale === 'uk' ? 'Попередній слайд' : 'Предыдущий слайд',
//   },
//   on: {
//     init(swiper) {
//       setTimeout(() => {
//         swiper.slides.forEach(slide => {
//           slide.removeAttribute('role');
//         });
//       }, 0);
//       updateSwiperStatus(swiper);

//       lastActiveIndex = swiper.activeIndex;
//     },

//     slideChange(swiper) {
//       updateSwiperStatus(swiper);

//       const bullets = swiper.pagination.bullets;
//       if (bullets[lastActiveIndex]) {
//         bullets[lastActiveIndex].style.setProperty('--progress', 0);
//       }
//       lastActiveIndex = swiper.activeIndex;
//     },

//     // тут від Swiper отримуємо прогрес autoplay
//     autoplayTimeLeft(swiper, time, progress) {
//       const bullets = swiper.pagination.bullets;
//       const activeBullet = bullets[swiper.activeIndex];
//       if (!activeBullet) return;

//       // progress: 0 → тільки почалося, 1 → зараз переключиться
//       activeBullet.style.setProperty('--progress', 1 - progress);
//     },
//   },
//   breakpoints: {
//     100: {
//       slidesPerView: 'auto',
//     },
//     1024: {
//       slidesPerView: 5,
//     }
//   }
// });

// const subscribeProducts = new Swiper('.subscribe__step-products', {
//   slidesPerView: 4,
//   spaceBetween: 16,
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true,
//   },
//   navigation: {
//     prevEl: '.subscribe__step-controls-prev',
//     nextEl: '.subscribe__step-controls-next'
//   },
//   a11y: {
//     enabled: true,
//     slideLabelMessage: '',
//     paginationBulletMessage:
//       Shopify.locale === 'uk'
//         ? 'Перейти до слайду {{index}}'
//         : 'Перейти к слайду {{index}}',
//     nextSlideMessage:
//       Shopify.locale === 'uk' ? 'Наступний слайд' : 'Следующий слайд',
//     prevSlideMessage:
//       Shopify.locale === 'uk' ? 'Попередній слайд' : 'Предыдущий слайд',
//   },
// })

// кнопка Play / Pause
const autoplayToggleBtn = document.querySelector('.subscription-page__banner-button');

if (autoplayToggleBtn) {
  autoplayToggleBtn.addEventListener('click', () => {
    if (!subscribeBanner.autoplay) return;

    if (subscribeBanner.autoplay.running) {
      subscribeBanner.autoplay.stop();
      autoplayToggleBtn.classList.add('is-paused');
    } else {
      subscribeBanner.autoplay.start();
      autoplayToggleBtn.classList.remove('is-paused');
    }
  });
}

